"use client";
import { useCallback } from "react";
import { useAuthenticate } from "../../../hooks/useAuthenticate.js";
import { useAuthContext } from "../context.js";
export const useOAuthVerify = ({ config, }) => {
    const { setAuthStep } = useAuthContext();
    const { authenticate: authenticate_, isPending } = useAuthenticate({
        onMutate: () => {
            setAuthStep({
                config,
                type: "oauth_completing",
            });
        },
        onError: (err) => {
            console.error(err);
            setAuthStep({
                type: "oauth_completing",
                config,
                error: err,
            });
        },
        onSuccess: () => {
            setAuthStep({ type: "complete" });
        },
    });
    const authenticate = useCallback(() => {
        authenticate_({
            ...config,
            type: "oauth",
        });
    }, [authenticate_, config]);
    return {
        isPending,
        authenticate,
    };
};
//# sourceMappingURL=useOAuthVerify.js.map